import { render, staticRenderFns } from "./AlertImages.vue?vue&type=template&id=7b87a57b&scoped=true"
import script from "./AlertImages.vue?vue&type=script&lang=js"
export * from "./AlertImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b87a57b",
  null
  
)

export default component.exports